<template>
  <transition
    name="slide-in-down"
    appear
    :appear-active-class="`animated ${$vuetify.rtl ? 'slideInRight' : 'slideInLeft'}`"
  >
    <v-navigation-drawer
      id="sidebar"
      v-model="drawer"
      fill-height
      clipped
      dark
      app
      :permanent="drawer"
      :width="sidebarWidth"
      :right="$vuetify.rtl"
    >
      <v-list id="sidebar-menu" class="transparent">
        <v-list-tile
          v-for="(link, index) in filteredSidebars()"
          :key="link.title"
          class="sidebar-icon-container"
          :style="index === 0 ? 'padding-top: 10px' : ''"
        >
          <transition
            name="slide-in-out"
            appear
            :appear-active-class="`animated ${$vuetify.rtl ? 'fadeInRight' : 'fadeInLeft'}`"
          >
            <a
              :href="link.to"
              :class="{ active: setActiveClass(link) }"
              :style="`animation-delay: ${1 + 0.08 * index}s`"
              @click.prevent="navigateTo(link)"
            >
              <v-icon>{{ link.icon }}</v-icon>
              <v-list-tile-title>{{ $t(link.title) }}</v-list-tile-title>
            </a>
          </transition>
          <v-divider v-if="index !== sidebarLinks.length - 1" style="margin-top:12px;" />
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'Sidebar',

  props: ['drawer'],

  data() {
    return {
      clickedLink: ''
    }
  },

  computed: {
    ...mapGetters({
      sidebarWidth: 'dashboard/sidebarWidth',
      sidebarLinks: 'dashboard/sidebarLinks',
      sidebarSubLinks: 'dashboard/sidebarSubLinks',
      currentSubLinks: 'dashboard/currentSubLinks',
      toggleSidebarSubMenu: 'dashboard/toggleSidebarSubMenu'
    })
  },

  mounted() {
    setTimeout(() => {
      this.fixSidebarListTileIssue()
    }, 1000)
  },

  watch: {
    drawer: {
      immediate: true,
      handler() {
        if (!this.drawer) {
          this.closeSidebarSubMenu()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateSidebarSubMenu: 'dashboard/updateSidebarSubMenu',
      showSidebarSubMenu: 'dashboard/showSidebarSubMenu',
      closeSidebarSubMenu: 'dashboard/closeSidebarSubMenu'
    }),

    filteredSidebars() {
      return this.sidebarLinks.filter(item => item.id === 0 || helpers.userHasSidebarPermissions(item.id))
    },

    fixSidebarListTileIssue() {
      // applying below styling through CSS didn't work even with !important, fix it with JS
      let vListTile = document.querySelectorAll('.sidebar-icon-container .v-list__tile')

      vListTile.forEach(element => {
        element.style.display = 'inline-block'
        element.style.padding = '0'
        element.style.width = '100%'
      })
    },

    navigateTo(link) {
      if (this.sidebarSubLinks[link.slug]) {
        // if the current clicked sidebar has submenu and its submenu not already shown then update the
        // submenu links and store the current link value, else if it's the same just clicked link we
        // close the submenu and set currentLink  value to empty
        if (this.clickedLink !== link) {
          this.clickedLink = link
          // if there're sublinks for the clicked menu item then show the submenu
          this.updateSidebarSubMenu(this.sidebarSubLinks[link.slug])
        } else {
          // console.warn('tt:', this.toggleSidebarSubMenu)
          if (!this.toggleSidebarSubMenu) {
            // console.warn('tt:', this.toggleSidebarSubMenu)
            this.showSidebarSubMenu(true)
          } else {
            this.clickedLink = ''
            this.closeSidebarSubMenu()
          }
        }
      } else {
        // if not, then close the submenu if its shown and directly navigate to the direct link
        this.clickedLink = ''
        this.closeSidebarSubMenu()
        this.$router.push(link.to)
      }
    },

    setActiveClass(link) {
      if (link.to === this.$route.path) {
        return true
      }
      if (this.$route.meta.parentPath && this.$route.meta.parentPath === link.to) {
        return true
      }
    }
  }
}
</script>

<style scoped>
#sidebar-menu {
  padding-top: 0px;
}
#sidebar {
  background: rgba(3, 13, 39, 0.9);
  animation-delay: 0.5s;
  max-width: 100% !important;
  padding-top: 0px;
}
#sidebar::-webkit-scrollbar {
  background: rgb(31, 55, 85);
  border-left: 1px solid rgb(3, 22, 46);
  width: 10px;
}
#sidebar::-webkit-scrollbar-thumb {
  background: rgb(1, 11, 24);
  border-radius: 10px;
}

.sidebar-icon-container {
  padding-top: 10px;
  /* margin-top: 10px; */
}
.sidebar-icon-container a {
  display: block;
  width: 100%;
  height: 100%;
  color: rgba(255, 255, 255, 0.7) !important;
  text-decoration: none;
  text-align: center;
  -webkit-user-drag: none;
  transition: all 0.1s;
}
.sidebar-icon-container .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
  display: inline-block;
  width: 90px;
  font-size: 30px;
  transition: all 0.3s;
}

.sidebar-icon-container:hover,
.sidebar-icon-container:focus {
  background: rgba(2, 9, 27, 0.85) !important;
}
.sidebar-icon-container a:hover,
.sidebar-icon-container a:focus,
.sidebar-icon-container a:hover .v-icon,
.sidebar-icon-container a:focus .v-icon {
  color: rgba(255, 255, 255, 0.95) !important;
  outline: none;
}
.sidebar-icon-container .v-list__tile__title {
  text-align: center;
  /* margin-top: 2px; */
}
.sidebar-icon-container a.active,
.sidebar-icon-container a.active .v-icon {
  color: rgb(255, 208, 0) !important;
}

#sidebar-submenu {
  position: fixed;
  z-index: 10000 !important;
  top: 0;
  left: auto;
  right: 0;
  background: rgba(50, 50, 50, 0.5);
  transform: translateX(-100px);
  width: 200px;
  height: calc(100vh - 60px);
}
</style>
